<template>
  <v-dialog @click:outside="onClose" v-model="dialog" max-width="410">
    <v-card class="card">
      <v-icon class="card-close" size="medium" color="icon" @click="onClose"> mdi-close </v-icon>
      <v-card-title class="card-title">
        {{ title }}
      </v-card-title>
      <v-card-text>
        {{ text }}
      </v-card-text>
      <slot />
      <v-card-actions class="actions">
        <v-btn class="btn btn-cancel" outlined color="#E5E5E5" @click="onClose">
          <span>{{ cancelText }}</span>
        </v-btn>
        <v-btn class="btn" :color="confirmColor || 'success'" dark @click="onConfirm" depressed>
          <v-progress-circular v-if="loading" indeterminate color="white" width="3" size="25" />
          <span v-else>{{ confirmText }}</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "Confirm",
  props: {
    dialog: Boolean,
    confirmText: String,
    title: String,
    text: String,
    cancelText: String,
    loading: Boolean,
    confirmColor: String,
  },
  methods: {
    onClose() {
      this.$emit("toggleDialog");
    },
    onConfirm() {
      this.$emit("confirm");
    },
  },
};
</script>
<style lang="scss" scoped>
.card {
  padding: 1rem;
  position: relative;
  &-title {
    word-wrap: break-word;
    word-break: keep-all;
  }

  &-close {
    position: absolute !important;
    top: 17px;
    right: 16px;
    width: 0.1rem;
    height: 0.1rem;
  }
}
.btn {
  text-transform: capitalize;
  font-weight: 600;

  &-cancel {
    span {
      color: #ccccce;
    }
  }
}
.actions {
  justify-content: flex-end;
  display: flex;
}
</style>
